import { VscFoldDown } from 'react-icons/vsc';
import { VscEdit } from 'react-icons/vsc';
import { MdOutlineCancel } from 'react-icons/md';

import { useState } from 'react';
import '../../css/adminStyling.css';

import { handleData } from '../../api';


const AdminUser = (props) => {

    const { user, updateUserList } = props;
    const { naam, loginemail, gebruikersnaam, _id, voornaam, tussenvoegsel, achternaam, info="", taken } = user;

    console.log(taken);

    const [foldDown, setFoldDown] = useState(false);
    const [edit, setEdit ] = useState({
        loginemail: {
            edit: false,
        },
        gebruikersnaam: {
            edit: false
        },
        naam: {
            edit: false
        },
        update: {
            loginemail: loginemail,
            gebruikersnaam: gebruikersnaam,
            voornaam: voornaam,
            tussenvoegsel: tussenvoegsel,
            achternaam: achternaam
        }
    });

    const handleClickEdit = (e) => {
        e.preventDefault();
        const field = e.target.name;
        setEdit({
            ...edit,
            [field]: {
                ...edit[field],
                edit: true
            }
        })
    }
    
    const handleClickCancel = (e) => {
        e.preventDefault();
        const field = e.target.name;
        setEdit({
            ...edit,
            [field]: {
                ...edit[field],
                edit: false
            },
            update: {
                ...edit.update,
                [field]:user[field]
            }
        })
        
    }

    const handleChange = (e) => {
        e.preventDefault();
        const field = e.target.name;
        setEdit({
            ...edit,
            update: {
                ...edit.update,
                [field]: e.target.value
            }
        })
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        setEdit((prevEdit) => {
            return {
                ...prevEdit,
                loginemail: {
                    edit: false,
                },
                gebruikersnaam: {
                    edit: false
                },
                naam: {
                    edit: false
                }
            }
        });
        const path = `users/update/${_id}`;
        const data = {
            method: 'PATCH',
            path: path,
            input: edit.update
        }
        const result = await handleData(data);
        
        if (result.data.success) {
            const updatedUser = result.data.data;
            updateUserList('update', _id, updatedUser);
        }

    }

    const handleDeleteAccount = async() => {
        const path = `users/verwijder/${_id}`;
        const data = {
            method: 'DELETE',
            path: path,
        }
        const result = await handleData(data);
        if(result.data.success) {
            updateUserList('delete', _id);
        }
    }


    const handleChangePassword = () => {

    }



    const handleFoldDown = () => {
        setFoldDown(prevfoldDown => !prevfoldDown);
    }




    return (
        <>
            {console.log(taken)}
            <div className='adminUserContainer'>
                <div className={`userTop ${foldDown ? "active" : ""}`} onClick={handleFoldDown}>
                    <p>{naam}</p>
                    <p>{gebruikersnaam} <span>{info && "(*info)"}</span></p>
                    <div className='userTopIcon'>
                        <span className={foldDown ? "active" : ""}><VscFoldDown /></span>
                    </div>
                </div>
                <div className= {`userFoldOut ${foldDown ? "active" : ""}`}>
                    {/* <p>details</p> */}
                    <div className='editSection'>
                        <div className='userEditItem loginemail'>
                            <div>
                                {!edit.loginemail.edit &&
                                    <button onClick={handleClickEdit} name="loginemail">
                                        <span className='icon'><VscEdit /></span>
                                    </button>
                                } 
                            </div>
                            <p className='editItemTitle'>Loginemail: </p>
                            <p>{loginemail}</p>
                            <div>
                                {edit.loginemail.edit 
                                && 
                                <div className='naamInput'>
                                    <label htmlFor="loginemail">Wijzig:</label>
                                    <input 
                                    className='editInput'
                                    type="text" 
                                    value={edit.update.loginemail} 
                                    onChange={handleChange} 
                                    name='loginemail'
                                    id='loginemail'
                                />
                                </div>
                                }
                            </div>
                            <div className='cancelButton'>
                                {edit.loginemail.edit && 
                                <div className='cancelSubmitButtons'>
                                    <button onClick={handleClickCancel} name="loginemail">
                                        <span className='icon'><MdOutlineCancel /></span>
                                    </button>
                                </div> }
                            </div>
                        </div>

                        <div className='userEditItem username'>
                            <div>
                                {!edit.gebruikersnaam.edit &&  
                                    <button onClick={handleClickEdit} name="gebruikersnaam">
                                        <span className='icon'><VscEdit /></span>
                                    </button>
                                }
                            </div>
                            <p className='editItemTitle'>Gebruikersnaam: </p>
                            <p>{gebruikersnaam}</p>
                            <div>
                                {edit.gebruikersnaam.edit 
                                && 
                                <div className='naamInput'>
                                    <label htmlFor="gebruikersnaam">Wijzig:</label>
                                    <input 
                                        className='editInput'
                                        type="text" 
                                        value={edit.update.gebruikersnaam} 
                                        onChange={handleChange} 
                                        name='gebruikersnaam'
                                        id='gebruikersnaam'
                                    />
                                </div>
                                }
                            </div>
                            <div className='cancelButton'>
                                {edit.gebruikersnaam.edit && 
                                    <div className='cancelSubmitButtons'>
                                        <button onClick={handleClickCancel} name="gebruikersnaam">
                                            <span className='icon'><MdOutlineCancel /></span>
                                        </button>
                                    </div> 
                                }
                            </div>
                        </div>

                        <div className='userEditItem naam'>
                            <div>
                                {!edit.naam.edit &&  
                                    <button onClick={handleClickEdit} name="naam">
                                        <span className='icon'><VscEdit /></span>
                                    </button> 
                                } 
                            </div>

                            <p className='editItemTitle'>Naam: </p>
                            <p>{naam}</p>
                            <div className='naamContainer'>
                                <div>
                                    {edit.naam.edit 
                                    && 
                                    <div className='naamInput'>
                                        <label htmlFor="voornaam">Voornaam:</label>
                                        <input 
                                            className='editInput'
                                            type="text" 
                                            value={edit.update.voornaam} 
                                            onChange={handleChange} 
                                            name='voornaam'
                                            id='voornaam'
                                        />

                                    </div>
                                    }

                                </div>
                                <div>
                                    {edit.naam.edit 
                                    && 
                                    <div className='naamInput'>
                                        <label htmlFor="tussenvoegsel">Tussenvoegsel:</label>
                                        <input 
                                            className='editInput'
                                            type="text" 
                                            value={edit.update.tussenvoegsel} 
                                            onChange={handleChange} 
                                            name='tussenvoegsel'
                                            id='tussenvoegsel'
                                        />
                                    </div>
                                    }
                                </div>
                                <div>
                                    {edit.naam.edit 
                                    && 
                                    <div className='naamInput'>
                                        <label htmlFor="achternaam">Achternaam:</label>
                                        <input 
                                            className='editInput'
                                            type="text" 
                                            value={edit.update.achternaam} 
                                            onChange={handleChange} 
                                            name='achternaam'
                                            id='achternaam'
                                        />
                                    </div>
                                    }
                                </div>

                            </div>
                            <div className='cancelButton'>
                                {edit.naam.edit &&
                                    <div className='cancelSubmitButtons'>
                                        <button onClick={handleClickCancel} name="naam">
                                            <span className='icon'><MdOutlineCancel /></span>
                                        </button>
                                    </div> 
                                }
                            </div>
                        </div>
                        
                        <div>
                            <p className='editItemTitle'>Extra info toegevoegd door gebruiker: </p>
                            <p>{info || "--" }</p>
                        </div>
                        <div>
                            <h3>Vrijwilligersaanmeldingen: </h3>
                            <table>
                                <thead>
                                    <tr>
                                        <td>Datum</td>
                                        <td>Activiteit</td>
                                        <td>Taak</td>
                                        <td>Aanmelding bevestigd</td>
                                        <td>Voltooing bevestigd</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {taken && taken.map(taakZ => {
                                        return (
                                        <tr key={taakZ.activiteitID}>
                                            <td>{taakZ.activiteitDatum}</td>
                                            <td>{taakZ.activiteitNaam}</td>
                                            <td>{taakZ.taakNaam}</td>
                                            <td>{taakZ.taakBevestigd ? "Ja": "Nee"}</td>
                                            <td>{taakZ.taakVoltooid ? "Ja" : "Nee"}</td>
                                        </tr>
                                        );
                                        
                                    })}

                                </tbody>
                            </table>
                            

                            
                        </div>
                    </div>   
                    <div className='adminUserOptionsFooter'>
                        <button onClick={handleDeleteAccount}>Account verwijderen</button>
                        <button onClick={handleChangePassword}>Nieuw wachtwoord genereren</button>
                        {(edit.loginemail.edit || edit.gebruikersnaam.edit || edit.naam.edit) && 
                        <button onClick={handleSubmit}>Bevestig wijzigingen</button> }

                    </div>


                </div>

            </div>
        </>
    );
}

export default AdminUser;